import { render, staticRenderFns } from "./SearchResultEmpty.vue?vue&type=template&id=023152dc&scoped=true&"
import script from "./SearchResultEmpty.vue?vue&type=script&lang=ts&"
export * from "./SearchResultEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023152dc",
  null
  
)

export default component.exports